module.exports = __webpack_public_path__ + "img/TeamComic_018.ea6b9afd.png";